<template>
    <div class="d-flex align-items-stretch">
        <parens
            v-if="showParens"
            left />
        <div class="d-flex justify-content-center static px-1">
            {{ textValue }}
        </div>
        <parens v-if="showParens" />
    </div>
</template>
<script>
    import { EXPRESSION_TYPES } from "Formula/expressionTypes";
    import base from "./_baseExpression.vue";
    import { convertValueToString } from "Util/util";

    export default {
        extends: base,
        props: {
            expression: { type: Object, required: true },
            getText: { type: Function, required: true }
        },
        computed: {
            showParens() {
                //In Tool Box Mode,always show parens. In edit mode, never show parens around contant value even when null.
                //For Edit Mode, show Parens only when numeric constant or date constant is null
                return (
                    this.formulaControl.inToolboxMode ||
                    (this.formulaControl.inEditMode && (this.textValue === "Constant" || this.textValue === "Date"))
                );
            },
            textValue() {
                let val = convertValueToString(this.getText(this.$app, this.expression));
                switch (this.expression.Type) {
                    case EXPRESSION_TYPES.StringConstant:
                        if ((val === "Text" || val === "") && !this.formulaControl.inToolboxMode) {
                            val = "Empty";
                        } else if (val.trim() === "") {
                            val = "Space(" + val.length + ")";
                        }
                        break;
                    case EXPRESSION_TYPES.DateConstant:
                        if (val === "Date" && this.formulaControl.inViewMode) {
                            val = "Date Constant";
                        }
                        break;
                }
                return val;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .static {
        min-width: 2rem;
    }
</style>
